import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FormInlineRowComponent } from './../forms/form-inline-row';
import { MessageComponent, BaseComponent } from '../common/common-components';
import { DictionaryService } from "../services/dictionary-service";
import { MessageService } from "../services/message-service";
import { ContactService } from "./contact-service";
import { UserService } from './../user/user-service';
declare var ga: any;
declare var DobryKantor: any;

let _: any = require("lodash");

@Component({
    selector: 'dk-contact-page',
    inputs: ['id'],
    template: require('./contact-page.html'),
    providers: [ContactService, MessageService]
})

export class ContactPageComponent extends BaseComponent implements OnInit {
    id: any;

    DobryKantor: any;

    form: FormGroup = new FormGroup({
        Email: new FormControl('', Validators.required),
        Phone: new FormControl(''),
        Content: new FormControl('', Validators.required),
    });

    constructor(private contactService: ContactService,
        private messageService: MessageService,
        private userService: UserService) {
        super();

        this.DobryKantor = DobryKantor;
    }

    submit() {
        this.touchFormGroup(this.form);

        if (this.form.valid) {
            this.contactService.sendContactMessage(this.form.value).subscribe(success => {
                if (success) {
                    this.messageService.success('Dziękujemy za kontakt. Nasi pracownicy odpowiedzą w najbliższym czasie.');
                    this.form.controls['Content'].setValue('');
                    this.untouchFormGroup(this.form);
                } else {
                    this.messageService.error('Przepraszamy. Wysłanie zapytania nie powiodło się.');
                }
            })
        }
    }

    showDepartment() {
        return this.DobryKantor.params.cantor.version != "doradcyfirmy" && this.DobryKantor.params.cantor.version != "wymianywalut";
    }

    public ngOnInit() {
        this.userService.account().subscribe((details: any) => {
            this.form.controls['Email'].setValue(details.Email);
            this.form.controls['Phone'].setValue(details.Phone);
        })
    }
}
